import React from "react";
import * as Animate from "react-reveal";
import BoardroomImage from "../../../assets/images/png/mba/mba-boardroom.jpg";
import { ArrowUpRight } from "../../../components/svgs";

const APPLY_URL = "https://utiva.co/mba/apply";

const deliverables = [
  "Business diagnosis",
  "Strategic recommendation",
  "Financial impact analysis",
  "AI opportunity assessment",
  "90-day implementation roadmap",
  "Presentation and defence",
];

const MBACapstoneSection = () => {
  return (
    <section className="py-16 md:py-24 lg:py-28 px-4" id="capstone">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-mba-capstone gap-10 lg:gap-16 items-center">
          <Animate.Fade bottom>
            <figure className="relative m-0 rounded-3xl overflow-hidden bg-primary h-[420px] md:h-[610px]">
              <img
                src={BoardroomImage}
                alt="African professional presenting a strategy recommendation to business leaders"
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <span
                className="absolute inset-x-0 bottom-0 h-[35%] bg-gradient-to-t from-black/70 to-transparent"
                aria-hidden="true"
              ></span>
              <figcaption className="absolute left-7 right-7 bottom-7 grid gap-1.5">
                <span className="font-poppins text-secondary text-xs font-extrabold tracking-widest uppercase">
                  The boardroom strategy simulation
                </span>
                <strong className="font-poppins text-white text-lg font-semibold">
                  Make the recommendation. Defend the decision.
                </strong>
              </figcaption>
            </figure>
          </Animate.Fade>

          <Animate.Fade bottom>
            <div>
              <p className="flex items-center gap-3 font-poppins text-primary text-sm font-extrabold tracking-widest uppercase mb-5">
                <span className="w-8 h-0.5 bg-secondary inline-block flex-shrink-0"></span>
                Capstone project
              </p>
              <h2 className="font-poppins text-primary font-bold tracking-tight text-3xl md:text-4xl leading-tight mb-5">
                Bring the whole program together around a real business
                challenge.
              </h2>
              <p className="font-poppins text-gray text-sm leading-loose mb-6">
                Present your recommendations as though you were addressing a
                leadership team, investor panel or corporate boardroom.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-7">
                {deliverables.map((item, i) => (
                  <div
                    key={item}
                    className="border border-hire-line bg-hire-tint-blue rounded-xl flex items-center gap-2.5 min-h-[68px] px-3.5"
                  >
                    <span className="font-poppins text-secondary font-extrabold text-sm">
                      0{i + 1}
                    </span>
                    <p className="font-poppins text-primary text-sm font-semibold m-0">
                      {item}
                    </p>
                  </div>
                ))}
              </div>

              <a
                href={APPLY_URL}
                className="font-poppins text-primary text-sm font-bold hover:underline underline-offset-4"
              >
                Apply for the next cohort{" "}
                <span aria-hidden="true">
                  <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
                </span>
              </a>
            </div>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default MBACapstoneSection;
